import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var LocationIcon = (props, _ref) => {
  var {
    attrs
  } = _ref;
  var _a, _b, _c, _d;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var {
    width,
    height,
    strokeColor,
    fillColor
  } = props;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.523 17.523",
    width: "".concat(width),
    height: "".concat(height),
    class: (_a = props.class) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, h("path", {
    fill: "none",
    stroke: "".concat((_c = attrs["stroke-color"]) !== null && _c !== void 0 ? _c : "#2b5dff"),
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "".concat((_d = attrs["stroke-width"]) !== null && _d !== void 0 ? _d : "1.5"),
    d: "m16.704 1.609-6.264 14.51a1.074 1.074 0 0 1-2.045-.248l-.827-4.929a1.2 1.2 \n        0 0 0-.987-.987L1.652  9.13a1.074 1.074 0 0 1-.248-2.046L15.918.819a.6.6 0 0 1 .786.79Z"
  }));
};